export class CommentModel {
  id?: string;
  name?: string;
  comment?: string;

  constructor(object?: Partial<CommentModel>) {
    Object.assign(this, object);
  }
}
